import { request } from "@/services/network";

export async function getSubscriptionDetails() {
	return request({
		url: "/payments/subscription-details/",
		method: "GET",
	});
}

export async function getPriceInfo() {
	return request({
		url: "/payments/price-info/",
		method: "GET",
	});
}

export async function createSubscriptionOrder(plan = "monthly") {
	return request({
		url: `/payments/create-subscription-order/?plan=${plan}`,
		method: "POST",
	});
}
